module.exports = __webpack_public_path__ + "static/media/cor.32dda65e.jpeg";